import React from "react";

const SPORTS = ["Football", "Basketball", "Rugby", "Handball", "Volleyball", "Tennis", "Athlétisme", "Hockey"];
const LEVELS = ["Loisir", "Départemental", "Régional", "National"];

export default function ClubBasicFields({ f, setF }) {
    return (
        <>
            <div>
                <label className="label-tu">Nom</label>
                <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="input-tu" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                    <label className="label-tu">Sport</label>
                    <select value={f.sport} onChange={(e) => setF({ ...f, sport: e.target.value })} className="input-tu">
                        {SPORTS.map((s) => <option key={s}>{s}</option>)}
                    </select>
                </div>
                <div>
                    <label className="label-tu">Niveau</label>
                    <select value={f.level} onChange={(e) => setF({ ...f, level: e.target.value })} className="input-tu">
                        {LEVELS.map((l) => <option key={l}>{l}</option>)}
                    </select>
                </div>
                <div>
                    <label className="label-tu">Département</label>
                    <input value={f.department} onChange={(e) => setF({ ...f, department: e.target.value })} className="input-tu" />
                </div>
                <div>
                    <label className="label-tu">Ville</label>
                    <input value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className="input-tu" />
                </div>
            </div>
        </>
    );
}
